import { useTranslation } from 'react-i18next';

import { Calendar } from 'tabler-icons-react';

import { SectionContainer, StyledButton } from 'components/shared';
import { getDayLabel } from 'utils/functions';

import styles from './OverviewRentalPeriodSection.module.css';

type OverviewRentalPeriodSectionProps = {
   palletDeliveryDate: string;
   holdingPeriod: string;
   retentionPeriodDays: string;
   onClickEdit?: () => void;
};

const OverviewRentalPeriodSection = ({
   palletDeliveryDate,
   holdingPeriod,
   retentionPeriodDays,
   onClickEdit,
}: OverviewRentalPeriodSectionProps) => {
   const { t } = useTranslation();

   return (
      <SectionContainer title={t('editRentalPeriod.title')}>
         {onClickEdit && (
            <StyledButton
               style={{ marginBottom: 24 }}
               variant="outlined-primary"
               text={t('overviewRentalPeriodSection.edit')}
               onClick={onClickEdit}
            />
         )}
         <div className={styles.dateContainer}>
            <div className={styles.dateInfo}>
               <p>{t('client_orders.table.delivered_date')}</p>
               <div>
                  <Calendar color="#3E3E4B" />
                  {palletDeliveryDate}
               </div>
            </div>
            <div className={styles.dateInfo}>
               <p>{t('editRentalPeriod.holdingPeriodLabel')}</p>
               <div>
                  <Calendar color="#3E3E4B" />
                  {holdingPeriod}
                  {` (${retentionPeriodDays} ${getDayLabel(Number(retentionPeriodDays))})`}
               </div>
            </div>
         </div>
      </SectionContainer>
   );
};

export default OverviewRentalPeriodSection;
